import { MapPin, Banknote, Phone, Lock } from 'lucide-react';
import { FeatureCard } from '@/components/ui/custom';
import { Reveal } from '@/components/system';

const features = [
  {
    title: 'Profissionais Angolanos',
    description: 'Todos os psicólogos são qualificados e falam português de Angola.',
    icon: MapPin,
  },
  {
    title: 'Preços em Kwanzas',
    description: 'Valores claros e acessíveis, sem surpresas. Paga da forma que te convém.',
    icon: Banknote,
  },
  {
    title: 'Atendimento via WhatsApp',
    description: 'Fala diretamente pelo WhatsApp, a app que já usas todos os dias.',
    icon: Phone,
  },
  {
    title: '100% Confidencial',
    description: 'A tua privacidade é a nossa prioridade. Tudo é seguro e discreto.',
    icon: Lock,
  },
];

export function FeaturesSection() {
  return (
    <section className="section-y bg-kuiva-pattern px-3 section-glass sm:px-6">
      <div className="mx-auto w-full min-w-0 max-w-6xl">
        <Reveal>
          <div className="mb-6 text-center sm:mb-8">
            <span className="glass-surface mb-3 inline-block rounded-full px-3 py-1 text-xs font-medium text-kuiva-blue sm:px-4 sm:py-1.5 sm:text-sm">
              Feito para Angola
            </span>
            <h2 className="mb-2 px-1 text-2xl font-bold text-foreground sm:text-3xl">
              Por que escolher a Kuiva?
            </h2>
            <p className="mx-auto max-w-lg text-sm text-muted-foreground sm:text-base">
              Solução pensada para Angola: preços em Kwanzas, WhatsApp e profissionais de confiança.
            </p>
          </div>
        </Reveal>

        <div className="grid gap-3 sm:grid-cols-2 sm:gap-4">
          {features.map((feature, index) => (
            <Reveal key={feature.title} delayMs={index * 85}>
              <FeatureCard {...feature} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
